module.exports = __webpack_public_path__ + "media/images/regions/Diffa-5efb9f4d1e1ed6f488988195e13df8e3.png";